import { call, put, takeLatest } from 'redux-saga/effects';
import HeroCommerceApi from 'api-services/HeroCommerceApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { MEMBERSHIP_CHANGE_PLAN } from './actionTypes';
import { membershipChangePlanDone, membershipChangePlanError } from './actionCreators';
import { getUserStatus } from '../userLogin/actionCreators';
import { logout } from '../auth/actionCreators';
export function* membershipChangePlan(constAccessParams, action) {
    const { key } = action.data;
    // Check public API access token
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroCommerceApi.changeMembershipPlan, newAccessParams, key);
    if (isSuccessResponse(result)) {
        yield put(membershipChangePlanDone());
        yield put(getUserStatus());
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(membershipChangePlanError(result));
    }
}
export function* watchMembershipChangePlanCalls(constAccessParams) {
    yield takeLatest(MEMBERSHIP_CHANGE_PLAN, membershipChangePlan, constAccessParams);
}
//# sourceMappingURL=saga.js.map